
(() => {
  "use strict";

  if (!location.pathname.includes("/products/")) return;

  const GROUP_SELECTOR = ".swatch--gl";
  const OPTION_SELECTOR = "li.select-option";

  function getProduct() {
    const scripts = document.querySelectorAll(
      'script[type="application/json"]'
    );

    for (const script of scripts) {
      try {
        const data = JSON.parse(script.textContent);

        if (
          Array.isArray(data.variants) &&
          Array.isArray(data.options) &&
          data.variants.length > 0 &&
          data.variants[0].option1 !== undefined
        ) {
          return data;
        }
      } catch (error) {
        // Ignora JSON non validi.
      }
    }

    return null;
  }

  function variantOption(variant, index) {
    return variant["option" + (index + 1)] ??
      variant.options?.[index];
  }

  function getGroups() {
    return [...document.querySelectorAll(GROUP_SELECTOR)]
      .map(group => {
        const input = group.querySelector(
          "input[data-globoswatchindex]"
        );

        const index = Number(
          input?.dataset.globoswatchindex?.replace(
            "option", ""
          )
        ) - 1;

        return {
          element: group,
          index,
          selected: group.querySelector(
            'input[type="radio"]:checked'
          )?.value
        };
      })
      .filter(group => group.index >= 0);
  }

  function setStatus(li, status) {
    const available = status === "available";
    const missing = status === "missing";

    li.classList.toggle("available", available);
    li.classList.toggle(
      "globo-out-of-stock",
      !available
    );
    li.classList.toggle(
      "cs-variant-available",
      available
    );
    li.classList.toggle(
      "cs-variant-unavailable",
      !available
    );
    li.classList.toggle(
      "cs-variant-missing",
      missing
    );

    const label = li.querySelector("label");
    if (!label) return;

    const overlays = label.querySelectorAll(
      ".gcw-sold-out-cross-overlay"
    );

    if (available) {
      overlays.forEach(overlay => overlay.remove());
    } else if (!overlays.length) {
      const overlay = document.createElement("span");
      overlay.className = "gcw-sold-out-cross-overlay";
      overlay.style.background =
        "linear-gradient(to right top," +
        "transparent calc(50% - 1px)," +
        "#b5b5b5 50%," +
        "transparent calc(50% + 1px))";

      label.appendChild(overlay);
    }
  }

  function updateSwatches(product) {
    const groups = getGroups();

    const sizeGroup = groups.find(g => g.index === 0);
    const colorGroup = groups.find(g => g.index === 1);

    if (!sizeGroup || !colorGroup) return;

    const selectedColor = colorGroup.selected;

    // Ricalcola le taglie in base al colore scelto.
    if (selectedColor) {
      sizeGroup.element
        .querySelectorAll(OPTION_SELECTOR)
        .forEach(li => {
          const size = li.querySelector("input")?.value;

          if (!size) return;

          const combinations = product.variants.filter(
            variant =>
              variantOption(variant, 0) === size &&
              variantOption(variant, 1) === selectedColor
          );

          const status = !combinations.length
            ? "missing"
            : combinations.some(v => v.available)
              ? "available"
              : "soldout";

          setStatus(li, status);
        });
    }

    // Ricalcola i colori in base alla taglia scelta.
    const selectedSize = sizeGroup.selected;

    if (selectedSize) {
      colorGroup.element
        .querySelectorAll(OPTION_SELECTOR)
        .forEach(li => {
          const color = li.querySelector("input")?.value;

          if (!color) return;

          const combinations = product.variants.filter(
            variant =>
              variantOption(variant, 0) === selectedSize &&
              variantOption(variant, 1) === color
          );

          const status = !combinations.length
            ? "missing"
            : combinations.some(v => v.available)
              ? "available"
              : "soldout";

          setStatus(li, status);
        });
    }
  }

  function init() {
    const product = getProduct();

    if (!product) {
      console.warn(
        "[CityStore] Dati prodotto non trovati"
      );
      return;
    }

    const style = document.createElement("style");
    style.textContent = `
      .swatch--gl li.cs-variant-available
      .gcw-sold-out-cross-overlay {
        display: none !important;
      }

      .swatch--gl li.cs-variant-available
      label::after {
        display: none !important;
      }

      .swatch--gl li.cs-variant-unavailable
      label {
        opacity: 0.55;
      }

      .swatch--gl li.cs-variant-available
      label {
        opacity: 1 !important;
      }
    `;
    document.head.appendChild(style);

    let timer;

    function scheduleUpdate() {
      clearTimeout(timer);

      timer = setTimeout(() => {
        updateSwatches(product);
      }, 100);
    }

    // Primo caricamento dopo l'inizializzazione Globo.
    setTimeout(scheduleUpdate, 400);
    setTimeout(scheduleUpdate, 1200);

    // Dopo ogni interazione, lascia prima lavorare Globo.
    document.addEventListener("click", event => {
      if (!event.target.closest(GROUP_SELECTOR)) return;

      setTimeout(scheduleUpdate, 150);
      setTimeout(scheduleUpdate, 500);
    });

    document.addEventListener("change", event => {
      if (!event.target.closest(GROUP_SELECTOR)) return;

      setTimeout(scheduleUpdate, 150);
      setTimeout(scheduleUpdate, 500);
    });

    console.log(
      "[CityStore] Correttivo Globo attivo:",
      product.variants.length,
      "varianti"
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      init,
      { once: true }
    );
  } else {
    init();
  }
})();
